/**
 * OrderedList — nested-level-aware <ol> renderer.
 *
 * Replaces the older ref/DOM-walk approach. Nesting depth is tracked
 * declaratively via React Context. Zero DOM reads on render.
 *
 * Levels map to the same class names the current CSS uses:
 *   1 → ol-level-1  (decimal)
 *   2 → ol-level-2  (lower-alpha)
 *   3 → ol-level-3  (lower-roman)
 *   4 → ol-level-4  (upper-alpha)
 *   5 → ol-level-5  (upper-roman)  — anything beyond also uses level-5.
 */
import React, { createContext, useContext } from 'react';

const OLDepthContext = createContext(0);

const OrderedList = ({ children, ...props }) => {
  const depth = useContext(OLDepthContext);
  const level = Math.min(depth + 1, 5);
  return (
    <OLDepthContext.Provider value={depth + 1}>
      <ol className={`ol-level-${level}`} {...props}>
        {children}
      </ol>
    </OLDepthContext.Provider>
  );
};

export default OrderedList;
